import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "time-toolbar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-angle-double-left" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-angle-double-right" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]


export default /*#__PURE__*/_defineComponent({
  __name: 'TimeToolbar',
  props: {
  title: {
    type: String,
    required: true,
  },
},
  emits: ['previous', 'next'],
  setup(__props, { emit }) {

const props = __props;





const previous = () => {
  emit('previous');
};
const next = () => {
  emit('next');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: previous,
      type: "button",
      class: "icon-only"
    }, _hoisted_3),
    _createElementVNode("h2", {
      textContent: _toDisplayString(props.title)
    }, null, 8, _hoisted_4),
    _createElementVNode("button", {
      onClick: next,
      type: "button",
      class: "icon-only"
    }, _hoisted_6)
  ]))
}
}

})